<script>
	import { Button, Col, Row } from "sveltestrap";
	import Loader from "../../../components/Loader/Loader.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import { form, field } from "svelte-forms";
	import { required, max } from "svelte-forms/validators";
	import client from "../../../services/client";
	import { navigate } from "svelte-routing";
	import { carparkDetail, errorMessage, loading } from "../../../store/store";
	import { extractErrorMessage } from "src/utils/misc";
	import { onMount } from "svelte";
	export let isEdit;
	export let carParkId;

	let duplicateNo;
	let parkingLotId = field("id", "", [required(), max(20)]);
	let level = field("level", "", [required()]);

	onMount(() => {
		if (isEdit) {
			const lot = $carparkDetail.carParkLots.find(
				(val) => (val.id = isEdit)
			);
			$parkingLotId.value = lot.lotNumber;
			$level.value = lot.level;
		}
	});

	const myForm = form(parkingLotId, level);

	const handleSubmit = () => {
		loading.set(true);
		const data = {
			lotNumber: $parkingLotId.value,
			level: $level.value,
			carParkId,
		};
		if (isEdit) {
			data.id = isEdit;
		}
		client(`/v1/carParks/lots`, {
			method: isEdit ? "PUT" : "POST",
			version: "Vehicle",
			data,
		})
			.then((res) => {
				loading.set(false);
				if (res.status === 200) {
					navigate(
						"/carpark-management/details/" + res.data.carParkId
					);
				}
			})
			.catch((err) => {
				loading.set(false);
				extractErrorMessage(err);
				console.log(err);
			});
	};

	let load = false;
	loading.subscribe((value) => {
		load = value;
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row class="my-3">
	<Col>
		<div>
			<ErrorMessageHandler message={err} />
			<Col xs={12}>
				<PageHeader
					title={isEdit ? "Edit Parking Lot" : "Add Parking Lot"}
				/>
				<p>*Mandatory Fields</p>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="parkingLotId" class="d-block">
							<span> <b>Parking Lot Id*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={3} class="mb-3">
						<div class="position-relative">
							<input
								type="text"
								class="form-control getgo input {$myForm.hasError(
									'parkingLotId.required'
								)
									? 'border border-danger'
									: ''}"
								bind:value={$parkingLotId.value}
								maxlength="20"
							/>
							<span
								class="text-count"
								style="
                            position: absolute;
                            bottom: 13%;
                            right: 18px;"
								>{!$parkingLotId.value
									? "0"
									: $parkingLotId.value.length} / 20</span
							>
						</div>
						{#if $myForm.hasError("parkingLotId.required")}
							<div>
								<p class="error-text">
									Parking lot ID is required
								</p>
							</div>
						{:else if $myForm.hasError("parkingLotId.max")}
							<div>
								<p class="error-text">Maximum 20 characters</p>
							</div>
						{:else if duplicateNo}
							<div>
								<p class="error-text">
									This Parking lot ID is already added
								</p>
							</div>
						{/if}
					</Col>
				</Row>
				<Row>
					<Col>
						<label for="parkingLotId" class="d-block">
							<span> <b>Level*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={3}>
						<div class="position-relative">
							<input
								type="text"
								class="form-control getgo input {$myForm.hasError(
									'level.required'
								)
									? 'border border-danger'
									: ''}"
								bind:value={$level.value}
							/>
						</div>
						{#if $myForm.hasError("level.required")}
							<div>
								<p class="error-text">Level is required</p>
							</div>
						{/if}
					</Col>
				</Row>
			</Col>
			<Col class="d-flex justify-content-end">
				<Row
					style="position: fixed; bottom: 40px; right: 40px; width: 300px;"
				>
					<Col>
						<Button class="themeButton" on:click={myForm.reset}
							>RESET</Button
						>
						<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
						<span
							class="d-inline-block"
							tabindex="0"
							data-bs-toggle={!$myForm.valid ? "tooltip" : ""}
							title={!$myForm.valid
								? "Fill all required field"
								: ""}
						>
							<Button
								class="themeButton primary"
								disabled={!$myForm.valid}
								on:click={() => handleSubmit()}
								on:click={myForm.validate}
							>
								{#if load}
									<Loader />
								{:else if isEdit}
									EDIT
								{:else}
									CREATE
								{/if}
							</Button>
						</span>
					</Col>
				</Row>
			</Col>
		</div>
	</Col>
</Row>
